module.exports = __webpack_public_path__ + "assets/musux.4d77bb9f.svg";